/*eslint react/jsx-key:0*/
import { components } from "react-select";
import { Checkbox } from "@carbon/react";

export const allOption = {
  label: "Select All",
  value: "*"
};

export const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <div className="select-option-lg">
        <Checkbox id="" labelText={props.label} checked={props.isSelected} onChange={() => null} />
      </div>
    </components.Option>
  );
};

export const OptionWithoutChekbox = (props: any) => {
  const { selectProps : { isSearchable } } = props;
  return (
    <div>
      <components.Option {...props}>
        <div className={isSearchable ? "select-option-lg" : "select-option-sm"}>
          <label>{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};
 
export const RemainingOptionsLabel = ({ remaining }: any) => (
  <div className="remaining-options-tag">
    +{remaining}
  </div>
);
export const ValueContainer = ({ children, ...props }: any) => {
  const currentValues = props.getValue();
  let toBeRendered = children;
  if (currentValues.some((val: any) => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]];
  } else if (currentValues.length > props.selectProps.maxOptionsToShow) {
    const optionsRemaining =
      currentValues.length - props.selectProps.maxOptionsToShow;
    toBeRendered = [
      [
        [
          ...children[0].slice(0, props.selectProps.maxOptionsToShow),
          <RemainingOptionsLabel remaining={optionsRemaining} />
        ]
      ],
      children[1]
    ];
  }

  return (
    <components.ValueContainer {...props}>
      {toBeRendered}
    </components.ValueContainer>
  );
};

export const MultiValue = (props: any) => {
  let labelToBeDisplayed = `${props.data[props.selectProps.labelKey]}`;
  if (props.data.value === allOption.value) {
    labelToBeDisplayed = props.selectProps.allSelectedText;
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  );
};

export const SingleValue = (props:any) => {
  const { children, ...rest } = props;
  const { selectProps } = props;
  let contents = children;
  if (selectProps.menuIsOpen && selectProps.isSearchable) {
    contents = selectProps.placeholder ? (
      <div style={{ color: "#999" }}>{selectProps.placeholder}</div>
    ) : (
      <></>
    );
  }
  return <components.SingleValue {...rest}>{contents}</components.SingleValue>;
};
